export const Notification = {
  event: {
    sms: 'Получать уведомления по SMS',
    email: 'Получать уведомления по эл. почте',
  },
  notification: {
    actionInfo: 'Получать информацию о проведении акций',
    personalOffer: 'Получать информацию о персональных предложениях',
    interview: 'Получать информацию о проведении опросов',
  },
};
